import axios from "axios";
import { BASEURL } from "baseUrl";
import { toast } from "react-toastify";

export const GET_TODAY_SALES = 'GET_TODAY_SALES';
export const APPOINTMENT_SALES = 'APPOINTMENT_SALES';
export const USER_REPORT = 'USER_REPORT';
export const DUE_AMOUNT_REPORT = 'DUE_AMOUNT_REPORT';
export const VIEW_REPORT = 'VIEW_REPORT';
export const FILE_CREATE_REPORT = 'FILE_CREATE_REPORT';
export const FILE_NOT_CREATE_REPORT = 'FILE_NOT_CREATE_REPORT';
export const GET_USER_EXCEL_DATA = 'GET_USER_EXCEL_DATA';
export const GET_SALES_EXCEL_DATA = 'GET_SALES_EXCEL_DATA';
export const GET_DUE_EXCEL_DATA = 'GET_DUE_EXCEL_DATA';
export const GET_APPOINTMENT_EXCEL_DATA = 'GET_APPOINTMENT_EXCEL_DATA';
export const GET_FILE_EXCEL_DATA = 'GET_FILE_EXCEL_DATA';
export const GET_FILE_NOT_EXCEL_DATA = 'GET_FILE_NOT_EXCEL_DATA';

const getTodaySalesAction = (payload) => ({ type: GET_TODAY_SALES, payload: payload });
const appointmentSalesAction = (payload) => ({ type: APPOINTMENT_SALES, payload: payload });
const userReportsAction = (payload) => ({ type: USER_REPORT, payload: payload });
const dueAmountReportsAction = (payload) => ({ type: DUE_AMOUNT_REPORT, payload: payload });
const viewReportsAction = (payload) => ({ type: VIEW_REPORT, payload: payload });
const fileCreateReportsAction = (payload) => ({ type: FILE_CREATE_REPORT, payload: payload });
const fileNotCreateReportsAction = (payload) => ({ type: FILE_NOT_CREATE_REPORT, payload: payload });
const getUserExcelAction = (payload) => ({ type: GET_USER_EXCEL_DATA, payload: payload });
const getSalesExcelAction = (payload) => ({ type: GET_SALES_EXCEL_DATA, payload: payload });
const getDueExcelAction = (payload) => ({ type: GET_DUE_EXCEL_DATA, payload: payload });
const getAppointmentExcelAction = (payload) => ({ type: GET_APPOINTMENT_EXCEL_DATA, payload: payload });
const getFileCreatedExcelAction = (payload) => ({ type: GET_FILE_EXCEL_DATA, payload: payload });
const getFileNotCreatedExcelAction = (payload) => ({ type: GET_FILE_NOT_EXCEL_DATA, payload: payload });

export const getTodaySales = (search,limits,payload) => {
    return async (dispatch) => {
        try {
            await axios.post(`${BASEURL}/consultantBilling/getPeymentReport?search=${search}&page=${limits.page}&limit=${limits.limit}`, payload).then(((res) => {
                dispatch(getTodaySalesAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(getTodaySalesAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const appointmentSales = (search,limits,payload) => {
    return async (dispatch) => {
        try {
            await axios.post(`${BASEURL}/appointment/pendingConfirmAppointments?search=${search}&page=${limits.page}&limit=${limits.limit}`, payload).then(((res) => {
                dispatch(appointmentSalesAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(appointmentSalesAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const userReports = (search,limits,payload) => {
    return async (dispatch) => {
        try {
            await axios.post(`${BASEURL}/receptionist/dateWisePatients?search=${search}&page=${limits.page}&limit=${limits.limit}`, payload).then(((res) => {
                dispatch(userReportsAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(userReportsAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const dueAmountReports = (search,limits,payload) => {
    return async (dispatch) => {
        try {
            await axios.post(`${BASEURL}/consultantBilling/getDueAmountPatientData?search=${search}&page=${limits.page}&limit=${limits.limit}`, payload).then(((res) => {
                dispatch(dueAmountReportsAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(dueAmountReportsAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const viewReports = (payload) => {
    return async (dispatch) => {
        try {
            await axios.post(`${BASEURL}/consultantBilling/getHistoryDataFromBillNumber`, payload).then(((res) => {
                dispatch(viewReportsAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(viewReportsAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const fileCreateReports = (limits,search,date,startDate,endDate) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/consultantBilling/fileCreatedOrNot?page=${limits.page}&limit=${limits.limit}&search=${search}&date=${date}&startDate=${startDate}&endDate=${endDate}&fileCreate=true`).then(((res) => {
                dispatch(fileCreateReportsAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(fileCreateReportsAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const fileNotCreateReports = (limits,search,date,startDate,endDate) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/consultantBilling/fileCreatedOrNot?page=${limits.page}&limit=${limits.limit}&search=${search}&date=${date}&startDate=${startDate}&endDate=${endDate}&fileCreate=false`).then(((res) => {
                dispatch(fileNotCreateReportsAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(fileNotCreateReportsAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const userExcelReports = (search,data) => {
    return async (dispatch) => {
        try {
            await axios.post(`${BASEURL}/receptionist/dateWisePatientsExport?search=${search}`,data).then(((res) => {
                dispatch(getUserExcelAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(getUserExcelAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const salesExcelReports = (search,data) => {
    return async (dispatch) => {
        try {
            await axios.post(`${BASEURL}/consultantBilling/getPeymentReportExport?search=${search}`,data).then(((res) => {
                dispatch(getSalesExcelAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(getSalesExcelAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const dueExcelReports = (search,payload) => {
    return async (dispatch) => {
        try {
            await axios.post(`${BASEURL}/consultantBilling/getDueAmountPatientDataExport?search=${search}`, payload).then(((res) => {
                dispatch(getDueExcelAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(getDueExcelAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const appointmentExcelReports = (search,payload) => {
    return async (dispatch) => {
        try {
            await axios.post(`${BASEURL}/appointment/pendingConfirmAppointmentsExport?search=${search}`, payload).then(((res) => {
                dispatch(getAppointmentExcelAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(getAppointmentExcelAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const fileCreateExcelReports = (search,data) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/consultantBilling/fileCreatedOrNotExport?search=${search}&date=${data.date}&startDate=${data.startDate}&endDate=${data.endDate}&fileCreate=true`).then(((res) => {
                dispatch(getFileCreatedExcelAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(getFileCreatedExcelAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const    fileNotCreateExcelReports = (search,data) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/consultantBilling/fileCreatedOrNotExport?search=${search}&date=${data.date}&startDate=${data.startDate}&endDate=${data.endDate}&fileCreate=false`).then(((res) => {
                dispatch(getFileNotCreatedExcelAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(getFileNotCreatedExcelAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}